import { InjectionToken, Signal, inject } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { OrganizationFeatures } from "@vp/models";
import { FeatureService } from "@vp/shared/features";

/** The flag's key under the `common` feature's `featureFlags`. */
export const NOTIFICATION_TRAY_FLAG = "notificationTrayEnabled";

/**
 * Whether the notification tray is available: the bottom-left trigger, the tray panel,
 * per-user persistence and urgent call lights that stay until they're opened or cleared.
 *
 * Off, notifications behave as they did before the tray (US408137): a sticky one floats
 * until the user dismisses it and nothing is stored. Held off pending staff training, so
 * turning it back on has to be a data change rather than a deployment — it reads the
 * organization's `common` feature flag, which is absent or `false` until someone sets it.
 *
 * The features are loaded in `APP_INITIALIZER` before the app renders, so the signal has
 * settled before any notification can be raised. `false` until then, and for an
 * organization with no `common` feature at all.
 */
export const NOTIFICATION_TRAY_ENABLED = new InjectionToken<Signal<boolean>>(
  "NOTIFICATION_TRAY_ENABLED",
  {
    providedIn: "root",
    factory: () =>
      toSignal(
        inject(FeatureService).featureFlagEnabled$(
          OrganizationFeatures.common,
          NOTIFICATION_TRAY_FLAG
        ),
        { initialValue: false }
      )
  }
);
